import { useParams } from '@fs/zion-router'
import { type PID } from '@fs/zion-tree-types'
import { pidRegexStr } from '@fs/zion-pid'
import { type PathParamMap } from '../../utils/pathParamTypes'

export const DETAILS_OPT_IN_OUT_PATHS = [
  `/details/:action(opt-in|opt-out)`,
  `/details/:pid(${pidRegexStr as PID})/:action(opt-in|opt-out)`,
] as const

type DetailsOptInOutParams = PathParamMap<typeof DETAILS_OPT_IN_OUT_PATHS>

export const useDetailsOptInOutParams = (): DetailsOptInOutParams => useParams<DetailsOptInOutParams>()
